module.exports = __webpack_public_path__ + "media/images/share-b0b797e1d3746b9c67c3aab387987fd3.svg";